export const BUSINESS_LABEL = { cafe: 'Café', restaurant: 'Restaurant', fastfood: 'Fast food', lounge: 'Lounge', sweets: 'Sweets & bakery', retail: 'Retail store', other: 'Other' };
export const businessLabel = (c, other) => (c ? (c === 'other' && other ? `Other: ${other}` : BUSINESS_LABEL[c] || c) : '—');
